import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09ffe12a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("picture", null, [
    /*#__PURE__*/_createElementVNode("source", {
      srcset: "assets/img/PeopleForce_Logo_DarkBG.png",
      media: "(prefers-color-scheme:dark)"
    }),
    /*#__PURE__*/_createElementVNode("img", { src: "assets/img/PeopleForce_Logo_WhiteBG.png" })
  ])
], -1))
const _hoisted_2 = { class: "form-wrapper" }
const _hoisted_3 = { id: "bt-wrapper" }
const _hoisted_4 = { class: "form-wrapper" }
const _hoisted_5 = { id: "bt-wrapper" }

import { IonPage, IonItem, IonInput, IonButton, IonContent, toastController, loadingController } from '@ionic/vue';
import { ref } from 'vue';
import { useI18n } from "vue-i18n";
import { useAuthStore } from '@/stores/auth.store';

/*
there are 2 steps for login: _identify_ is used to specify the identifier phone nb, _login_ to specify the OTC
*/

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const step1 = ref(null);
const step2 = ref(null);
let personnelId = -1;
const identifier = ref(''); //need to make a reactive store that can be exported and updated
const code = ref('');
const { t } = useI18n();
const auth = useAuthStore();

/**
 * _identify_ form submission callback
 * switch the form state to _login_ if the step is succesful
 */
const onIdentify = async function () {

    const loading = await loadingController.create({
        message: t('p.login.load-identify')
    });

    loading.present();

    const result = await auth.identify(identifier.value);
    loading.dismiss();

    if (result && result.status == 1 && result.personnelId && result.personnelId > 0) {
        personnelId = result.personnelId;
        (step1.value as any).style.display = 'none';
        (step2.value as any).style.display = 'block';
    } else {
        (step1.value as any).style.display = 'block';
        (step2.value as any).style.display = 'none';

        const toast = await toastController.create({
            message: t('p.login.unknown-user-id'),
            duration: 5000,
            color: 'warning',
        });
        toast.present();
    }
}

/**
 * _login_ form submission callback
 * if the login fails, reactivate the form, otherwise redirect to root page
 */
const onLogin = async function () {
    const loading = await loadingController.create({
        message: t('p.login.load-code'),
    });

    loading.present();

    const result = await auth.login(parseInt(code.value), personnelId);
    loading.dismiss();

    if (result && result.token) {
        console.log('SUCCESS LOGGED');
        // const navCtrl: HTMLIonRouterElement = await (this.nav as any).componentOnReady();
        // navCtrl.push('/');
        window.location.href = '/';
    } else {
        
        const toast = await toastController.create({
            message: t('p.login.invalid-otc'),
            duration: 5000,
            color: 'warning',
        });
        toast.present();
        console.log('FAIL LOGGED');
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", {
            ref_key: "step1",
            ref: step1,
            id: "step1"
          }, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('p.login.title')), 1),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonInput), {
                    type: "text",
                    "label-placement": "floating",
                    inputMode: "tel",
                    label: _ctx.$t('p.login.input-lb'),
                    autocapitalize: "none",
                    modelValue: identifier.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((identifier).value = $event))
                  }, null, 8, ["label", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(IonButton), {
                expand: "block",
                onClick: onIdentify
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('p.login.bt')), 1)
                ]),
                _: 1
              })
            ])
          ], 512),
          _createElementVNode("div", {
            ref_key: "step2",
            ref: step2,
            id: "step2"
          }, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('p.login.code-title')), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonInput), {
                    type: "text",
                    "label-placement": "floating",
                    label: _ctx.$t('p.login.code-lb'),
                    name: "Code",
                    autocapitalize: "none",
                    modelValue: code.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((code).value = $event))
                  }, null, 8, ["label", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(IonButton), {
                expand: "block",
                onClick: onLogin
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('p.login.code-bt')), 1)
                ]),
                _: 1
              })
            ])
          ], 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})